import React from "react";

export default function PrivacyPolicyPage() {
  const containerStyle = {
    maxWidth: "850px",
    margin: "0 auto",
    padding: "40px 20px",
    fontFamily:
      "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    lineHeight: 1.6,
    color: "#222",
  };

  const homeLinkStyle = {
  display: "inline-block",
  marginBottom: "20px",
  color: "#2b6cb0",
  textDecoration: "none",
  fontSize: "14px",
};

  const headingStyle = {
    marginTop: "32px",
  };

  const handleMouseOver = (e) => {
    e.currentTarget.style.textDecoration = "underline";
    };

    const handleMouseOut = (e) => {
    e.currentTarget.style.textDecoration = "none";
    };


  return (
    <div style={containerStyle}>
        <a
        href="/"
        style={homeLinkStyle}
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}
        >
        ← Return to Home
        </a>

      <h1>Privacy Policy</h1>

      <p>
        <strong>Last Updated:</strong> February 13, 2026
        <br />
        <strong>Effective Date:</strong> February 13, 2026
      </p>

      <p>
        This Privacy Policy describes the policies of Sparks Psychological
        Services, LLC & Associates, 8118 Corporate Way, Suite 121, Ohio 45040,
        United States of America, email: sparksllc@icloud.com, phone:
        513-297-3455, regarding the information that we may collect when you use
        our website (the “Service”).
      </p>

      <p>
        By accessing or using the Service, you consent to the collection, use,
        and disclosure of your information in accordance with this Privacy
        Policy. If you do not agree, please do not access or use the Service.
      </p>

      <p>
        We may modify this Privacy Policy at any time without prior notice. The
        revised Privacy Policy will be posted on this page and will become
        effective 180 days after posting. Your continued use of the Service after
        that time constitutes acceptance of the revised Privacy Policy.
      </p>

      <h2 style={headingStyle}>Sensitive Information</h2>

      <p>
        Please do not submit sensitive personal, medical, or confidential
        information through this website. This website is not intended for the
        transmission of protected health information (PHI). If you are a current
        or prospective client, please contact our office directly by phone.
      </p>

      {/* ⭐ This line is VERY important for therapists */}
      <p>
        Electronic communication through this website may not be secure and
        should not be used to transmit sensitive or confidential information.
      </p>

      <h2 style={headingStyle}>Information We May Collect</h2>

      <p>
        We may collect limited personal information if you voluntarily provide it
        to us, such as your name, email address, phone number, or any details you
        choose to include in a message.
      </p>

      <p>
        We may also collect certain non-personal information automatically
        through standard website technologies such as server logs or analytics
        tools, if implemented.
      </p>

      <h2 style={headingStyle}>How We Use Your Information</h2>

      <ul>
        <li>Respond to inquiries and provide support</li>
        <li>Maintain the safety, security, and integrity of our website</li>
        <li>Provide administrative communications when necessary</li>
      </ul>

      <p>
        If we wish to use your information for any other purpose, we will request
        your consent and will use your information only for the purpose(s) for
        which consent was granted, unless otherwise required by law.
      </p>

      <h2 style={headingStyle}>How We Share Your Information</h2>

      <p>We do not sell, rent, or trade your personal information.</p>

      <p>
        We may share your information with trusted third-party service providers
        who assist us in operating our website, provided they agree to use the
        information only for the purpose for which it was provided and to protect
        it appropriately.
      </p>

      <p>
        We may also disclose your personal information if required to do so by
        law, regulation, court order, or other legal process.
      </p>

      <h2 style={headingStyle}>Third-Party Services and Links</h2>

      <p>
        Our website may contain links to third-party websites or services. We are
        not responsible for the privacy practices of those third parties and
        encourage you to review their privacy policies before providing any
        personal information.
      </p>

      <h2 style={headingStyle}>Data Retention</h2>

      <p>
        We retain personal information only for as long as necessary to fulfill
        the purposes outlined in this Privacy Policy, unless a longer retention
        period is required or permitted by law.
      </p>

      <h2 style={headingStyle}>Your Rights</h2>

      <p>
        Depending on applicable laws, you may have the right to access, correct,
        or request deletion of your personal data, obtain a copy of your personal
        data, restrict or object to certain processing activities, withdraw
        consent where applicable, or lodge a complaint with a regulatory
        authority.
      </p>

      <p>
        To exercise these rights, you may contact us at
        officemanager@sparkspsychservices.com. We will respond in accordance with
        applicable law.
      </p>

      <h2 style={headingStyle}>Cookies and Tracking Technologies</h2>

      <p>
        We may use cookies or similar technologies to enhance your browsing
        experience.
      </p>

      <p>
        Some cookies are essential for the proper functioning of the website and
        cannot be disabled.
      </p>

      <p>
        For more information about how we use cookies and your choices regarding
        them, please refer to our <a href="/cookie-policy">Cookie Policy</a>.
      </p>

      <h2 style={headingStyle}>Security</h2>

      <p>
        We take reasonable administrative, technical, and physical safeguards to
        protect your information from loss, misuse, unauthorized access,
        disclosure, alteration, or destruction. However, no internet transmission
        is ever completely secure, and we cannot guarantee absolute security.
      </p>

      <h2 style={headingStyle}>Contact Information</h2>

      <p>
        If you have questions or concerns about this Privacy Policy, you may
        contact:
      </p>

      <p>
        Sparks Psychological Services, LLC & Associates
        <br />
        8118 Corporate Way, Suite 121
        <br />
        Ohio 45040
        <br />
        Email: officemanager@sparkspsychservices.com
      </p>
    </div>
  );
}
